/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import PharmacyPaymentHistory from './pharmacy-payment-history';
import PharmacyPaymentHistoryDetail from './pharmacy-payment-history-detail';
import PharmacyPaymentHistoryUpdate from './pharmacy-payment-history-update';
import PharmacyPaymentHistoryDeleteDialog from './pharmacy-payment-history-delete-dialog';

const PharmacyPaymentHistoryRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<PharmacyPaymentHistory />} />
    <Route path="new" element={<PharmacyPaymentHistoryUpdate />} />
    <Route path=":id">
      <Route index element={<PharmacyPaymentHistoryDetail />} />
      <Route path="edit" element={<PharmacyPaymentHistoryUpdate />} />
      <Route path="delete" element={<PharmacyPaymentHistoryDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default PharmacyPaymentHistoryRoutes;
